import { useRouter } from 'next/navigation';
import { type PropsWithChildren, createContext, useContext } from 'react';

interface RouterContextInterface {
  handleNavigation: (...args: any[]) => void;
}

export const RouterContext = createContext<RouterContextInterface | null>(null);

export const RouterProvider = ({ children }: PropsWithChildren) => {
  const router = useRouter();

  const handleNavigation = (path: string, forceReload: boolean = false) => {
    if (forceReload) {
      router.refresh();
      return;
    }

    if (path) {
      router.push(path);
    }
  };

  return (
    <RouterContext.Provider value={{ handleNavigation }}>
      {children}
    </RouterContext.Provider>
  );
};

export function useCustomRouter() {
  const context = useContext(RouterContext);
  if (context == null) {
    throw new Error('useCustomRouter must be used within RouterProvider');
  }

  return context;
}
